export default {
  profileCreated: 'profileCreated',
  existing: 'existing',
  returned: 'returned',
  opened: 'opened',
  notSent: 'notSent',
  notOpened: 'notOpened',
  invited: 'invited',
}
